import { DeleteApiClient, GetApiClient } from "@/utils/api-client";
import { DataSchema } from "common";

type GetChatsResponse = DataSchema.ChatMetadataList;
export const getChatsApi = (apiClient: GetApiClient) => {
  return apiClient.get<GetChatsResponse>("/api/chats");
};

type GetChatResponse = DataSchema.Chat;
export const getChatApi = (apiClient: GetApiClient, id: string) => {
  return apiClient.get<GetChatResponse>(`/api/chats/${id}`);
};

export const deleteChatApi = (apiClient: DeleteApiClient, id: string) => {
  return apiClient.del(`/api/chats/${id}`);
};
